import React from "react";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { CardActions } from "@material-ui/core";
import { ArrowBack, PhoneOutlined, Replay, Cached } from "@material-ui/icons";
import { OrderActionType, OrderDataStatus } from "../Order";

export function BottomDrawer(props: any) {
	const history = useHistory();
	const {
		status,
		orderStatus,
		showReopenButton,
		setStatus,
		dataProvider,
		id,
		setRetryCount,
		orderBehavior,
	} = props;

	if (
		status !== OrderDataStatus.DATA_FETCHED ||
		![
			OrderActionType.openingLockerError,
			OrderActionType.completed,
		].includes(orderStatus)
	) {
		return null;
	}

	let title = "";
	let Actions: JSX.Element | null = null;

	const isShowReopenButton = orderBehavior.openAgainButton
		? showReopenButton && orderBehavior.openAgainButton.show
		: showReopenButton;

	if (orderStatus === OrderActionType.completed && isShowReopenButton) {
		title = "Hai dimenticato di ritirare qualcosa?";
		const showOpenAgainButtonText = orderBehavior.openAgainButton?.text || "Riapri il fridge";
		Actions = (
			<Button
				onClick={() => {
					setStatus(OrderDataStatus.REQUEST_REOPEN);
					dataProvider(
						`b2c/locker/selling-order/info/${id}/retry-opening`
					)
						.then(() => {
							setStatus(OrderDataStatus.DATA_FETCHED);
						})
						.catch(() => {
							setStatus(OrderDataStatus.DATA_FETCHED);
						});
				}}
				fullWidth={true}
				variant="outlined"
				color="primary"
				startIcon={<Cached />}
			>
				{showOpenAgainButtonText}
			</Button>
		);
	}

	if (orderStatus === OrderActionType.completed && !isShowReopenButton) {
		title = "";
		Actions = (
			<Button
				onClick={() => {
					history.push(`/selling-area/${id}`);
				}}
				fullWidth={true}
				variant="contained"
				color="primary"
				startIcon={<ArrowBack />}
			>
				Torna al menu
			</Button>
		);
	}

	if (orderStatus === OrderActionType.openingLockerError) {
		title = "Il Fridge non si è aperto?";
		Actions = (
			<>
				<Button
					size="large"
					fullWidth={true}
					variant="outlined"
					startIcon={
						<PhoneOutlined style={{ color: "rgb(232, 84, 21)" }} />
					}
					style={{
						borderColor: "rgb(232, 84, 21)",
					}}
				>
					<a
						style={{
							textDecoration: "none",
							color: "rgb(232, 84, 21)",
						}}
						href="tel:+390289763305"
					>
						Contattaci
					</a>
				</Button>
				<Button
					size="large"
					onClick={() => {
						setStatus(OrderDataStatus.REQUEST_REOPEN);
						dataProvider(
							`b2c/locker/selling-order/info/${id}/retry-opening`
						)
							.then(() => {
								setRetryCount(0);
								setStatus(OrderDataStatus.FETCH_DATA);
							})
							.catch(() => {
								setStatus(OrderDataStatus.DATA_FETCHED);
							});
					}}
					fullWidth={true}
					variant="contained"
					color="primary"
					startIcon={<Replay />}
				>
					RIPROVA
				</Button>
			</>
		);
	}

	if (!title && !Actions) {
		return null;
	}

	return (
		<Card style={{ width: "100%", padding: "8px" }} elevation={24}>
			{title && (
				<CardContent>
					<Typography variant="body1" align="center">
						{title}
					</Typography>
				</CardContent>
			)}
			<CardActions style={{ padding: "8px" }}>{Actions}</CardActions>
		</Card>
	);
}
